module.exports = __webpack_public_path__ + "media/images/h_r/btn_hotel_en-615e2255c7de34876468ae1fafc426cb.jpg";